/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import clsx from '@proton/utils/clsx';

import { MIME_ICON_VIEWBOX, type MimeIconComponentProps, getMimeIconAsset } from '../component';

export const MimePages = ({ alt, title, size = 4, className, ...rest }: MimeIconComponentProps) => {
    const asset = getMimeIconAsset(size);

    return (
        <>
            <svg
                role="img"
                viewBox={MIME_ICON_VIEWBOX[asset]}
                focusable="false"
                className={clsx(`icon-size-${size}`, className)}
                {...rest}
            >
                {title ? <title>{title}</title> : null}
                {asset === 'sm' && (
                    <g>
                        <rect width="16" height="16" rx="2" fill="#FFA733"></rect>
                        <path
                            d="M9.78276 5.00148L5.89276 8.89148C5.83609 8.94815 5.79302 9.01842 5.77753 9.09738L5.56084 9.96691C5.54063 10.0506 5.61316 10.1231 5.70138 10.1074L6.5709 9.89076C6.64533 9.87073 6.72014 9.8322 6.77681 9.77553L10.6668 5.88553C10.7896 5.76274 10.7888 5.57308 10.6755 5.45974L10.2085 4.99279C10.0952 4.87945 9.90082 4.88342 9.78276 5.00148Z"
                            fill="white"
                        ></path>
                        <path
                            d="M4.7998 11C4.7998 10.8895 4.88935 10.8 4.9998 10.8H10.5998C10.7103 10.8 10.7998 10.8895 10.7998 11C10.7998 11.1104 10.7103 11.2 10.5998 11.2H4.9998C4.88935 11.2 4.7998 11.1104 4.7998 11Z"
                            fill="white"
                        ></path>
                    </g>
                )}
                {asset === 'md' && (
                    <g>
                        <path
                            d="M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V21.5C24 22.8807 22.8807 24 21.5 24H2.5C1.11929 24 0 22.8807 0 21.5V2.5Z"
                            fill="#FFA733"
                        ></path>
                        <path
                            d="M15.1198 6.75261L8.31234 13.5601C8.21316 13.6593 8.13778 13.7823 8.11067 13.9204L7.73147 15.4421C7.6961 15.5885 7.82304 15.7155 7.97742 15.688L9.49908 15.3088C9.62933 15.2738 9.76024 15.2064 9.85942 15.1072L16.6669 8.29969C16.8818 8.08481 16.8805 7.75291 16.6821 7.55457L15.865 6.73739C15.6666 6.53905 15.3264 6.54599 15.1198 6.75261Z"
                            fill="white"
                        ></path>
                        <path
                            d="M6.3999 17.25C6.3999 17.0567 6.5566 16.9 6.7499 16.9H16.5499C16.7432 16.9 16.8999 17.0567 16.8999 17.25C16.8999 17.4433 16.7432 17.6 16.5499 17.6H6.7499C6.5566 17.6 6.3999 17.4433 6.3999 17.25Z"
                            fill="white"
                        ></path>
                    </g>
                )}
                {asset === 'lg' && (
                    <g>
                        <path
                            d="M3.38989 7.82502C3.38989 4.03082 6.4657 0.955017 10.2599 0.955017H27.948C29.7182 0.955017 31.4201 1.63835 32.6988 2.86253L42.4907 12.2369C43.8444 13.5328 44.6099 15.3254 44.6099 17.1994V42.175C44.6099 45.9692 41.5341 49.045 37.7399 49.045H10.2599C6.4657 49.045 3.38989 45.9692 3.38989 42.175V7.82502Z"
                            fill="#FFA733"
                        ></path>
                        <path
                            d="M44.4743 15.84H35.4501C32.2883 15.84 29.7251 13.2768 29.7251 10.115V1.18878C30.8323 1.48528 31.8573 2.05674 32.699 2.86252L42.491 12.2369C43.5123 13.2146 44.1988 14.4751 44.4743 15.84Z"
                            fill="#FFD466"
                        ></path>
                        <path
                            d="M44.6101 17.5575H35.4501C31.3397 17.5575 28.0076 14.2254 28.0076 10.115V0.955261C28.5922 0.960314 29.169 1.03987 29.7251 1.18877V10.115C29.7251 13.2768 32.2882 15.84 35.4501 15.84H44.4743C44.5639 16.2841 44.6101 16.7393 44.6101 17.1993V17.5575Z"
                            fill="#F2860D"
                        ></path>
                        <path
                            d="M28.4569 22.5037L18.7319 32.2287C18.5902 32.3703 18.4825 32.546 18.4438 32.7434L17.9021 34.9172C17.8516 35.1264 18.0329 35.3078 18.2535 35.2686L20.4273 34.7269C20.6133 34.6768 20.8003 34.5805 20.942 34.4388L30.667 24.7138C30.974 24.4068 30.9721 23.9327 30.6888 23.6493L29.5214 22.4819C29.238 22.1986 28.7521 22.2085 28.4569 22.5037Z"
                            fill="white"
                        ></path>
                        <path
                            d="M16 37.5C16 37.2239 16.2239 37 16.5 37H30.5C30.7761 37 31 37.2239 31 37.5C31 37.7761 30.7761 38 30.5 38H16.5C16.2239 38 16 37.7761 16 37.5Z"
                            fill="white"
                        ></path>
                    </g>
                )}
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
